export const appVersion = { major: 1, minor: 6, patch: 11 };
export const apiHost = 'devapi';
export const welcomeMessage = 'Welcome';
export const environ = 'live';
export const openQuickText = () => {
  window.open('https://quicktext-us.web.app/browser', '_blank');
};
export const loggingState = true;
export const tokenUrl =
  'https://devapi.afteraction.com/api/sendcode/api_live.php';
export const purchases = 'real';
export const propertiesVersion = 1;
export const firebaseConfig = {
  apiKey: 'AIzaSyBms3NB2ye3b7T95KYszdDU83vTw_cCKx4',
  authDomain: 'quicktext-us.firebaseapp.com',
  databaseURL: 'https://quicktext-us.firebaseio.com',
  projectId: 'quicktext-us',
  storageBucket: 'quicktext-us.appspot.com',
  messagingSenderId: '1075783056205',
  appId: '1:1075783056205:web:849f468d88497aaf005504',
  measurementId: 'G-G82SN59ZJ1',
};
